import { motion } from 'framer-motion';
import './RaginiPromises.css';

const promises = [
  {
    id: '01',
    title: "Stone-Ground Mastery",
    desc: "Ground slowly on stone to preserve the true soul of flavor.",
    tag: "Purity",
    icon: "🗿"
  },
  {
    id: '02',
    title: "Zero Toxins",
    desc: "100% pure with absolutely zero preservatives or fillers.",
    tag: "Nature",
    icon: "🌿"
  },
  {
    id: '03',
    title: "Fair Sourcing",
    desc: "We work directly with small farmers for ethical harvests.",
    tag: "Ethics",
    icon: "🤝"
  },
  {
    id: '04',
    title: "Heritage Recipes",
    desc: "Preserving recipes whispered through generations.",
    tag: "Legacy",
    icon: "🏺"
  },
  {
    id: '05',
    title: "Small Batches",
    desc: "Never mass-produced to ensure undivided attention.",
    tag: "Focus",
    icon: "💎"
  },
  {
    id: '06',
    title: "Sun-Dried",
    desc: "Naturally cured by the sun to lock in nutrients.",
    tag: "Natural",
    icon: "☀️"
  }
];

const RaginiPromises = () => {
  return (
    <section className="ragini-promises">
      <div className="container">
        <div className="promises-header">
          <motion.span 
            className="section-tag"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            Our Sacred Vow
          </motion.span>
          <motion.h2 
            className="promises-main-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            The <span className="italic-serif">Ragini</span> Promises
          </motion.h2>
        </div>

        <div className="promises-grid-innovative">
          {promises.map((promise, index) => (
            <motion.div 
              key={promise.id}
              className="promise-card-premium"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              <div className="promise-bg-number">{promise.id}</div>
              <div className="promise-card-inner">
                <div className="promise-top">
                  <span className="promise-tag-mini">{promise.tag}</span>
                  <span className="promise-icon-float">{promise.icon}</span>
                </div>
                <h3 className="promise-title">{promise.title}</h3>
                <p className="promise-desc">{promise.desc}</p>
                <div className="promise-hover-line" />
              </div>
            </motion.div>
          ))}
        </div>

        {/* Decorative elements */}
        <div className="promises-deco-bottom">
          <div className="seal-of-purity">
            <div className="seal-text">GUARANTEED AUTHENTIC • SINCE 2005 •</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RaginiPromises;
